import { z } from "zod";
import { vacationDaysAccrualTypes } from "../../absences";
import { REGIONS } from "../../misc";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

export const employmentFormSchema = z.object({
	region: z.enum(REGIONS),
	jobTitle: z.string(),
	validFrom: z.string(),
	validTo: ZodStringNullable,
	hoursPerWeek: z.number(),
	workdays: z.array(z.number()),
	vacationDays: z.number(),
	vacationDaysAccrualType: z.enum(vacationDaysAccrualTypes),
});

export type EmploymentFormSchema = z.infer<typeof employmentFormSchema>;
